import React, { useEffect, useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";

import Container from "@material-ui/core/Container";
import { useStylesContainers, useStylesHed } from "../../../St/comps/UseStyle";
import StocksForm from "./stocks-form";
import StocksTable from "./stocks-table";
import toast, { Toaster } from "react-hot-toast";
import { insh, sto } from "../../../Context/InshData";
import basicDataAPI from "../../../api/basicData";
import useFormDataCRUD from "../../../components/Hooks/useEDSCURD";
import BasiceAppBar from "../components/basic-appBar";

export default function Stocks(props) {
  const { data, fetchURL } = props;
  const defaultValues = {
    ...insh.Stocks,
    branch: data?.auto?.Branches[0],
    status: data?.auto?.States[0],
  };

  const {
    onChange,
    submit,
    update,
    remove,
    submitting,
    errorMessage,
    onShow,
    onEnd,
    object,
    formType,
  } = useFormDataCRUD(
    basicDataAPI.create,
    basicDataAPI.update,
    basicDataAPI.removeStock,
    undefined,
    defaultValues,
    null,
    fetchURL
  );
  useEffect(() => {
    console.log("secound item", object);
  });

  const clsConts = useStylesContainers();
  const clashd = useStylesHed();
  const [branches, setBranches] = useState(() => {
    return [...data?.auto?.Branches,{ id: -1, name: "الكل" }];
});

  const onSubmitHandle = (data) => {
    if (data.name == "") {
      toast.error("ادخل اسم الصندوق");
    } else if (data.Stock_Emps.length == 0) {
      toast.error("حدد الموظف المسؤول عن الصندوق");
    } else {
      const Stock_Emps = data.Stock_Emps.map((se) => {
        return { emp_id: se.id, stock_id: 0 };
      });
      const tb = {
        stocks: { ...data, branch: data?.branch?.id, status: data.status.id },
        Stock_Emps: Stock_Emps,
        tbstate: { Stocks: true, parms: { tname: "Stocks" } },
        db_name: sto?.db_name,
      };
      delete tb.stocks.Stock_Emps;
      if (formType == "edit") update(tb);
      else submit(tb);
    }
  };

  const styheader = {
    textAlign: "center",
    backgroundColor: "#fff",
    height: "100vh",
    direction: "rtl",
  };

  return (
    <React.Fragment>
      <CssBaseline />

      <Container maxWidth="xl">
        <Toaster />

        <Typography component="div" style={styheader}>
          <Grid item container>
            <Grid item xs={12}>
              <Chip
                size="small"
                className={clashd.ChipHdSale}
                label={" الصنــــاديق"}
                color="primary"
              />
            </Grid>
            <Grid container xs={12}>
              <Grid
                item
                container
                lg={12}
                md={12}
                className={[clsConts.rootup]}
              >
                <Grid
                  item
                  container
                  spacing={1}
                  xs={12}
                  className={[clsConts.subUp, clsConts.subUpC]}
                >
                  <StocksForm
                    {...{
                      ...props,
                      onChange,
                      submit,
                      update,
                      remove,
                      submitting,
                      errorMessage,
                      onShow,
                      onEnd,
                      object,
                      formType,
                      branches
                    }}
                  />
                </Grid>
              </Grid>
              <StocksTable
                {...{ ...props, onShow, stocks: props.data?.table?.resData,branches }}
              />
            </Grid>
          </Grid>
          <BasiceAppBar
            {...{
              ...props,
              onSubmitHandle,
              onChange,
              defaultValues,
              submit,
              update,
              remove,
              submitting,
              errorMessage,
              onShow,
              onEnd,
              object,
              formType,
            }}
          />
        </Typography>
      </Container>
    </React.Fragment>
  );
}
